import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { removeCode } from "../CodingScreen/Service";



const RouteCleanupHandler = () => {
  const location = useLocation();
  // const prevPathRef = useRef(location.pathname);
//   const additionaldiagnosisStates =
//   JSON.parse(sessionStorage.getItem("additionalDiagnosisState")) || [];
// const procedureCodesState=JSON.parse(sessionStorage.getItem("procedureCodesState"))||[];
// const principalDiagnosisState=JSON.parse(sessionStorage.getItem("principalDiagnosisState"))||[]
//   const lastHcpLineId=sessionStorage.getItem("last_hcp_line_id");
  // console.log(diagnosisStates,'initialDiagnosisState');
const EXCLUDED_ROUTES = [
  "/episode-list",
  "/code-assist-episode-list",
  "/code-assist",
  "/coder",
  "/Auditor-Coding-Screen",
  "/Auditor-CodeAssist-Screen",
  "/auditor-coding-screen",
  "/auditor-codeassist-screen"
];
// console.log(EXCLUDED_ROUTES,'szdxfcghjkljszdfg');

const isExcludedRoute = (path) => {
  const p = path.toLowerCase();
  return EXCLUDED_ROUTES.some(r => p === r || p.startsWith(r + "/"));
};


const prevPathRef = useRef(null);

useEffect(() => {
  const currentPath = location.pathname;

  if (!isExcludedRoute(currentPath)) {
    callRemoveCode();
  }

}, [location.pathname]);


useEffect(() => {
  const handleBeforeUnload = () => {
    const payload = {
      hcp_line_id: sessionStorage.getItem("last_hcp_line_id"),
      principal_diagnosis_code:
        JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) || [],
      additional_diagnoses_code:
        JSON.parse(sessionStorage.getItem("initialadditionalDiagnosisState")) || [],
      procedure_codes:
        JSON.parse(sessionStorage.getItem("initialprocedureDiagnosisState")) || [],
    };

    if (!payload.hcp_line_id) return;

    navigator.sendBeacon(
      "/remove-code-api-endpoint",
      JSON.stringify(payload)
    );
  };

  window.addEventListener("beforeunload", handleBeforeUnload);
  return () =>
    window.removeEventListener("beforeunload", handleBeforeUnload);
}, []);


const callRemoveCode = async () => {
  const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
  const alreadyConfirmed = sessionStorage.getItem("isConfirmed") === "true";

  if (!hcpLineId) return;

  if (
    (!JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) &&
      !JSON.parse(sessionStorage.getItem("initialadditionalDiagnosisState")) &&
      !JSON.parse(sessionStorage.getItem("initialprocedureDiagnosisState"))) ||
    alreadyConfirmed
  ) {
    return;
  }

  try {
    await removeCode({
      hcp_line_id: hcpLineId,
      principal_diagnosis_code:
        JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) || [],
      additional_diagnosis_codes:
        JSON.parse(sessionStorage.getItem("initialadditionalDiagnosisState")) || [],
      procedure_codes:
        JSON.parse(sessionStorage.getItem("initialprocedureDiagnosisState")) || [],
    });

    sessionStorage.removeItem("initialprincipalDiagnosisState");
    sessionStorage.removeItem("initialadditionalDiagnosisState");
    sessionStorage.removeItem("initialprocedureDiagnosisState");

  } catch (error) {
    console.error("Remove code API failed:", error);
  }
};



  // useEffect(() => {
  //   prevPathRef.current = location.pathname;
  // }, [location.pathname]);

  return null;
};

export default RouteCleanupHandler;
